/**
 * theme.color
 */
const color = {
  // ----- Primary
  /**
   * @color #48189e
   */
  primary1: "#48189e",
  /**
   * @color #6024c6
   */
  primary2: "#6024c6",
  /**
   * @default
   * @color #7b3ff1
   */
  primary3: "#7b3ff1",
  /**
   * @color #9564f4
   */
  primary4: "#9564f4",
  /**
   * @color #b08cf7
   */
  primary5: "#b08cf7",
  /**
   * @color #cab2f9
   */
  primary6: "#cab2f9",
  /**
   * @color #dac7ff
   */
  primary7: "#dac7ff",
  /**
   * @color #e5d9fc
   */
  primary8: "#e5d9fc",
  /**
   * @color #f2ebfe
   */
  primary9: "#f2ebfe",
  /**
   * @color #f7f3ff
   */
  primary10: "#f7f3ff",

  // ----- Secondary
  /**
   * @color #276dae
   */
  secondary1: "#276dae",
  /**
   * @color #0f88c8
   */
  secondary2: "#0f88c8",
  /**
   * @color #28aeed
   */
  secondary3: "#28aeed",
  /**
   * @default
   * @color #29d1ff
   */
  secondary4: "#29d1ff",
  /**
   * @color #54daff
   */
  secondary5: "#54daff",
  /**
   * @color #7fe3ff
   */
  secondary6: "#7fe3ff",
  /**
   * @color #a9edff
   */
  secondary7: "#a9edff",
  /**
   * @color #d4f6ff
   */
  secondary8: "#d4f6ff",
  /**
   * @color #eafaff
   */
  secondary9: "#eafaff",

  // ----- Gray
  /**
   * @color #000000
   */
  gray1: "#000000",
  /**
   * @default
   * @color #282a2e
   */
  gray2: "#282a2e",
  /**
   * @color #3c3e42
   */
  gray3: "#3c3e42",
  /**
   * @subText
   * @color #5a5c60
   */
  gray4: "#5a5c60",
  /**
   * @color #96989c
   */
  gray5: "#96989c",
  /**
   * @color #bec0c4
   */
  gray6: "#bec0c4",
  /**
   * @color #dddfe2
   */
  gray7: "#dddfe2",
  /**
   * @color #e7e9ec
   */
  gray8: "#e7e9ec",
  /**
   * @color #eceef1
   */
  gray9: "#eceef1",
  /**
   * @color #f1f3f6
   */
  gray10: "#f1f3f6",
  /**
   * @color #f6f8fb
   */
  gray11: "#f6f8fb",
  /**
   * @color #ffffff
   */
  gray12: "#ffffff",

  // ----- Red
  /**
   * @color #d71308
   */
  red1: "#d71308",
  /**
   * @default
   * @color #ff3b30
   */
  red2: "#ff3b30",
  /**
   * @color #ff6d62
   */
  red3: "#ff6d62",
  /**
   * @color #ff9f94
   */
  red4: "#ff9f94",
  /**
   * @color #ffcdc6
   */
  red5: "#ffcdc6",
  /**
   * @color #fff2f0
   */
  red6: "#fff2f0",

  // ----- Orange
  /**
   * @color #e17700
   */
  orange1: "#e17700",
  /**
   * @default
   * @color #ff9500
   */
  orange2: "#ff9500",
  /**
   * @color #ffaa33
   */
  orange3: "#ffaa33",
  /**
   * @color #ffbf66
   */
  orange4: "#ffbf66",
  /**
   * @color #ffdfb3
   */
  orange5: "#ffdfb3",
  /**
   * @color #fff4e5
   */
  orange6: "#fff4e5",

  // ----- Yellow
  /**
   * @color #e1ae00
   */
  yellow1: "#e1ae00",
  /**
   * @default
   * @color #ffcc00
   */
  yellow2: "#ffcc00",
  /**
   * @color #ffd633
   */
  yellow3: "#ffd633",
  /**
   * @color #ffe066
   */
  yellow4: "#ffe066",
  /**
   * @color #fff0b3
   */
  yellow5: "#fff0b3",
  /**
   * @color #fffae5
   */
  yellow6: "#fffae5",

  // ----- Green
  /**
   * @color #16a93b
   */
  green1: "#16a93b",
  /**
   * @default
   * @color #34c759
   */
  green2: "#34c759",
  /**
   * @color #5dd57b
   */
  green3: "#5dd57b",
  /**
   * @color #86df9c
   */
  green4: "#86df9c",
  /**
   * @color #c2efce
   */
  green5: "#c2efce",
  /**
   * @color #ebfaef
   */
  green6: "#ebfaef",

  // ----- Mint
  /**
   * @color #284a5e
   */
  mint1: "#284a5e",
  /**
   * @default
   * @color #3b8c92
   */
  mint2: "#3b8c92",
  /**
   * @color #78b3c2
   */
  mint3: "#78b3c2",
  /**
   * @color #b2dde8
   */
  mint4: "#b2dde8",
  /**
   * @color #cff0f2
   */
  mint5: "#cff0f2",
  /**
   * @color #e1fcfe
   */
  mint6: "#e1fcfe",

  // ----- Teal
  /**
   * @color #3caadc
   */
  teal1: "#3caadc",
  /**
   * @default
   * @color #5ac8fa
   */
  teal2: "#5ac8fa",
  /**
   * @color #83d6fb
   */
  teal3: "#83d6fb",
  /**
   * @color #b5e6fd
   */
  teal4: "#b5e6fd",
  /**
   * @color #cdeffe
   */
  teal5: "#cdeffe",
  /**
   * @color #e6f7fe
   */
  teal6: "#e6f7fe",

  // ----- Blue
  /**
   * @color #005ce1
   */
  blue1: "#005ce1",
  /**
   * @default
   * @color #007aff
   */
  blue2: "#007aff",
  /**
   * @color #3395ff
   */
  blue3: "#3395ff",
  /**
   * @color #66afff
   */
  blue4: "#66afff",
  /**
   * @color #b3d7ff
   */
  blue5: "#b3d7ff",
  /**
   * @color #e5f2ff
   */
  blue6: "#e5f2ff",

  // ----- Pink
  /**
   * @color #d7052d
   */
  pink1: "#d7052d",
  /**
   * @default
   * @color #ff2d55
   */
  pink2: "#ff2d55",
  /**
   * @color #ff557d
   */
  pink3: "#ff557d",
  /**
   * @color #ff87af
   */
  pink4: "#ff87af",
  /**
   * @color #ffb9e1
   */
  pink5: "#ffb9e1",
  /**
   * @color #ffebff
   */
  pink6: "#ffebff",
};

export type ColorType = typeof color;

export default color;
